import { request } from "@/interface/helper";

const str = "marketingSubscribe";

export const marketingSubscribe = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/subscribe/list" }),
    edit: (data) => request({ data, method: "post", url: "/subscribe/modify" }),
  },
};
